import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { HomeLoanService } from '@home/home-loan/home-loan.service';

@Injectable({
  providedIn: 'root',
})
export class ExtendTermGuard implements CanActivate {
  constructor(private readonly homeLoanService: HomeLoanService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const loanId = route.params?.id;
    return this.validateExtendTermLoans(loanId);
  }

  private validateExtendTermLoans(loanId: string): Observable<boolean | UrlTree> {
    return this.homeLoanService.validateExtendTermLoans([loanId]).pipe(
      catchError(() => this.router.navigate(['/home'])),
      map((response) => response[0]?.verify || this.router.navigate(['/home']))
    );
  }
}
